(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('UploadnwController', UploadnwController);

    UploadnwController.$inject = ['Uploadnw', 'UploadnwSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'Propriedade', 'Safra', 'DataUtils', 'Principal'];

    function UploadnwController(Uploadnw, UploadnwSearch, ParseLinks, AlertService, paginationConstants, Propriedade, Safra, DataUtils, Principal) {

        var vm = this;

        vm.uploadnws = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        vm.selectedfile = null;
        vm.fileData = null;

        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        vm.propriedadeSelecionada = undefined;
        vm.safraSelecionada = undefined;

        vm.onSucessoSafra = onSucessoSafra;
        vm.onSucessoUpload = onSucessoUpload;
        vm.onFalhaUpload = onFalhaUpload;

        vm.safras = [];

        vm.converteDataAtual = converteDataAtual;
        vm.inicioUpload = null;
        vm.fimUpload = null;
        vm.currentAccount = null;

        vm.arquivoProcessamento = null;

        // Váriaveis de processamento mapas
        vm.procPlantaDaninha = false;
        vm.procLagarta = false;
        vm.procAmargoso = false;
        vm.procManchaAlvo = false;
        vm.procFerrugem = false;
        vm.procBuva = false;
        vm.procPercevejo = false;
        vm.procFalhaDePlantio = false;
        vm.procMilho = false;
        vm.procFolhaLarga = false;
        vm.procFolhaEstreita = false;

        // Váriaveis de processamento mapas - cana
        vm.procBicudo = false;
        vm.procCigarrinha = false;
        vm.procFolhaLargaCana = false;
        vm.procFolhaEstreitaCana = false;
        vm.procBrocaDaCana = false;
        vm.procPlantaDaninhaCana = false;

        vm.changePropriedade = function () {
            console.log("Change propriedade!");
            vm.safras = [];
            Safra.querySafrasPorPropriedade({
                idPropriedade: vm.propriedadeSelecionada.id
            }, vm.onSucessoSafra);
        }

        function onSucessoSafra(result){
            console.log(result);
            for (var i = 0; i < result.length; i++) {
                vm.safras.push(result[i]);
            }

            console.log(vm.safras);
        }

        vm.setFile = function ($file) {
            vm.fileData = null;
            console.log("Selecionado");
            vm.fileData = $file;
            console.log(vm.fileData);
        };

        vm.enviar = function () {
            vm.inicioUpload = vm.converteDataAtual();
            console.log("Sending...");
            var tipoArquivo = vm.fileData.name.substr(vm.fileData.name.length - 4);
            var blob = vm.fileData.slice(0, vm.fileData.size, vm.fileData.type); 
            var data = new Date();
            var dataString = ( data.getDate() + 1 < 10? '0' + (data.getDate()) : (data.getDate()) ) + ( data.getMonth() + 1 < 10? '0' + (data.getMonth() + 1) : (data.getMonth() +1) ) + data.getFullYear();

            var novonome = vm.safraSelecionada.id + '_' + dataString + tipoArquivo;

            var newFile = new File([blob], novonome, {type: vm.fileData.type});
            Uploadnw.upload(newFile, vm.onSucessoUpload, vm.onFalhaUpload);
        };

        function converteDataAtual(){

            var d = new Date();

            var dia = d.getDate(); dia < 10 ? dia = '0' + dia : dia;
            var mes = d.getMonth() + 1; mes < 10 ? mes = '0' + mes: mes;
            var ano = d.getFullYear();

            var hora = d.getHours();
            var min = d.getMinutes(); min < 10 ? min = '0' + min: min;
            var seg = d.getSeconds(); seg < 10 ? seg = '0' + seg: seg;

            return dia + '/' + mes + '/' + ano + ' ' + hora + ':' + min + ':' + seg;
        }

        function onFalhaUpload(error){
            AlertService.error(error.data.message);
        }

        function onSucessoUpload(data) {
            vm.fimUpload = vm.converteDataAtual();

            Principal.identity().then(function(account) {

                // Preparando log
                vm.currentAccount = account;
                
                var uploadLog = new Uploadnw();
                uploadLog.usuario = vm.currentAccount.login;

                var data = new Date();
                var dataString = ( data.getDate() + 1 < 10? '0' + (data.getDate()) : (data.getDate()) ) + ( data.getMonth() + 1 < 10? '0' + (data.getMonth() + 1) : (data.getMonth() +1) ) +  data.getFullYear();

                uploadLog.data = dataString;

                uploadLog.inicio = vm.inicioUpload;
                uploadLog.fim = vm.fimUpload;

                uploadLog.propriedade = vm.propriedadeSelecionada.nomepropriedade;

                // Preparando arquivo de apoio de processamento
                var nomeArquivoProcessamento = vm.safraSelecionada.id + '_' + dataString + '.txt';
                
                var textoArquivoProcessamento = "";

                textoArquivoProcessamento = textoArquivoProcessamento + vm.safraSelecionada.cultura_nome;

                if(vm.procLagarta){
                    textoArquivoProcessamento = textoArquivoProcessamento + ",lagarta";
                }
                if(vm.procAmargoso){
                    textoArquivoProcessamento = textoArquivoProcessamento + ",amargoso";
                }
                if(vm.procManchaAlvo){
                    textoArquivoProcessamento = textoArquivoProcessamento + ",manchaalvo";
                }
                if(vm.procFerrugem){
                    textoArquivoProcessamento = textoArquivoProcessamento + ",ferrugem";
                }
                if(vm.procBuva){
                    textoArquivoProcessamento = textoArquivoProcessamento + ",buva";
                }
                if(vm.procPercevejo){
                    textoArquivoProcessamento = textoArquivoProcessamento + ",percevejo";
                }
                if(vm.procFalhaDePlantio){
                    textoArquivoProcessamento = textoArquivoProcessamento + ",falhaplantio";
                }
                if(vm.procMilho){
                    textoArquivoProcessamento = textoArquivoProcessamento + ",milho";
                }
                if(vm.procFolhaLarga){
                    textoArquivoProcessamento = textoArquivoProcessamento + ",folhalarga";
                }
                if(vm.procFolhaEstreita){
                    textoArquivoProcessamento = textoArquivoProcessamento + ",folhaestreita";
                }
                if(vm.procPlantaDaninha){
                    textoArquivoProcessamento = textoArquivoProcessamento + ",plantadaninha";
                }
                
                if(vm.procBicudo){
                    textoArquivoProcessamento = textoArquivoProcessamento + ",bicudo";
                }
                if(vm.procCigarrinha){
                    textoArquivoProcessamento = textoArquivoProcessamento + ",cigarrinha";
                }
                if(vm.procFolhaLargaCana){
                    textoArquivoProcessamento = textoArquivoProcessamento + ",folhalargacana";
                }
                if(vm.procFolhaEstreitaCana){
                    textoArquivoProcessamento = textoArquivoProcessamento + ",folhaestreitacana";
                }
                if(vm.procBrocaDaCana){
                    textoArquivoProcessamento = textoArquivoProcessamento + ",brocadacana";
                }
                if(vm.procPlantaDaninhaCana){
                    textoArquivoProcessamento = textoArquivoProcessamento + ",plantadaninhacana";
                }

                
                var fileProc = {
                    fileContent: textoArquivoProcessamento,
                    fileName: nomeArquivoProcessamento
                };

                Uploadnw.uploadProc(fileProc);

                Uploadnw.save(uploadLog, vm.loadAll); // Salvando log
            });

        }

        vm.propriedades = Propriedade.queryNomesPropriedades({
            size: 1000
        });


        loadAll();

        function loadAll () {
            vm.uploadnws = [];

            if (vm.currentSearch) {
                UploadnwSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Uploadnw.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.uploadnws.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.uploadnws = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.uploadnws = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.uploadnws = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();
